import { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import axios from "@/shared/config/axios-interceptor";
import { formatMoney } from "@/shared/utils/ultils";
import dayjs from "dayjs";
import { statusTransaction } from "../HistoryWithdraw";
import { CSpinner } from "@coreui/react-pro";

const LichSuGiaoDich = () => {
  const [active, setActive] = useState(3);
  const [listTransaction, setListTransaction] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  const getTransactions = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `/transaction?limit=60&type=${active}&sortBy=id&sortOrder=DESC`
      );
      setListTransaction(res?.data?.data);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    getTransactions();
  }, [active]);

  const renderStatus = (status: number) => {
    switch (status) {
      case statusTransaction.success:
        return (
          <span className="align-content-center badge bg-success">
            Thành công
          </span>
        );
      case statusTransaction.error:
        return (
          <span className="align-content-center badge bg-danger">Thất bại</span>
        );

      default:
        return (
          <span className="align-content-center badge bg-secondary">
            Chờ xử lý
          </span>
        );
    }
  };

  return (
    <div className="wrapper">
      <div className="container-web lichsugiaodich bgnew">
        <Header title="Lịch sử giao dịch" />
        <main className="p-3">
          <div style={{ border: "2px solid #dea94f" }}>
            <div className="d-flex header-top align-items-center">
              <div
                className="w-100 text-center border-end"
                style={{
                  color: active == 3 ? "#dea94f" : "#fff",
                  cursor: "pointer",
                }}
                onClick={() => setActive(3)}
              >
                Gửi tiết kiệm
              </div>
              <div
                className="w-100 text-center"
                style={{
                  color: active == 2 ? "#dea94f" : "#fff",
                  cursor: "pointer",
                }}
                onClick={() => setActive(2)}
              >
                Rút tiền
              </div>
              <div
                style={{
                  color: active == 4 ? "#dea94f" : "#fff",
                  cursor: "pointer",
                }}
                onClick={() => setActive(4)}
                className="w-100 text-center border-start"
              >
                Phát sinh lợi nhuận
              </div>
            </div>

            {active === 1 && (
              <>
                <div className="d-flex align-items-center p-2 item">
                  <div className="w-100 text-center">Số tiền</div>
                  <div className="w-100 text-center">Thời gian</div>
                </div>

                {listTransaction?.map((item: any, index: number) => {
                  return (
                    <div
                      className="d-flex align-items-center p-2 item"
                      key={index}
                    >
                      <div className="w-100 text-center">
                        {formatMoney(item?.money ?? 0)} VNĐ
                      </div>
                      <div className="w-100 text-center">
                        {dayjs(item?.createdDate).format("DD/MM/YYYY")}
                      </div>
                    </div>
                  );
                })}
              </>
            )}

            {active === 2 && (
              <>
                <div className="d-flex align-items-center p-2 item">
                  <div className="w-100 text-center">Số tiền</div>
                  <div className="w-100 text-center">Thời gian</div>
                  <div className="w-100 text-center">Trạng thái</div>
                </div>

                {listTransaction?.map((item: any, index: number) => {
                  return (
                    <div
                      className="d-flex align-items-center p-2 item"
                      key={index}
                    >
                      <div className="w-100 text-center">
                        {formatMoney(item?.money ?? 0)} VNĐ
                      </div>
                      <div className="w-100 text-center">
                        {dayjs(item?.createdDate).format("DD/MM/YYYY")}
                      </div>
                      <div className="w-100 text-center">
                        {renderStatus(item?.status)}
                      </div>
                    </div>
                  );
                })}
              </>
            )}

            {active === 3 && (
              <>
                <div className="d-flex align-items-center p-2 item">
                  <div className="w-100 text-center">Số tiền</div>
                  <div className="w-100 text-center">Thời gian</div>
                </div>

                {listTransaction?.map((item: any, index: number) => {
                  return (
                    <div
                      className="d-flex align-items-center p-2 item"
                      key={index}
                    >
                      <div className="w-100 text-center">
                        {formatMoney(item?.money ?? 0)} VNĐ
                      </div>
                      <div className="w-100 text-center">
                        {dayjs(item?.createdDate).format("DD/MM/YYYY")}
                      </div>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </main>
        <Footer />
      </div>

      <div
        className={`bg-drop justify-content-center align-items-center gap-1 ${
          loading ? "d-flex" : "d-none"
        }`}
      >
        <CSpinner variant="grow" style={{ width: 23, height: 23 }} />
        <CSpinner variant="grow" style={{ width: 23, height: 23 }} />
        <CSpinner variant="grow" style={{ width: 23, height: 23 }} />
      </div>
    </div>
  );
};

export default LichSuGiaoDich;
